import 'numeral/locales/en-gb';

import numeral from 'numeral';

import { CURRENCY_CODE } from '@/constants/common';
import { parseCsvBudget } from '@/features/canvas/utils/csv-currency';

numeral.locale('en-gb');

/**
 * Parse an imported budget value into currency and amount. Recognises every symbol in
 * CSV_CURRENCY_SYMBOLS and every supported currency code; shared symbols (¥, kr) resolve to
 * `roadmapCurrency` when it is a candidate. Unparseable values return GBP 0.
 */
export const parseBudget = (
  budget: string,
  roadmapCurrency?: string
): { currency: keyof typeof CURRENCY_CODE; value: number } => {
  const parsed = parseCsvBudget(budget, roadmapCurrency);
  if (!parsed.ok) {
    return { currency: CURRENCY_CODE.GBP, value: 0 };
  }
  return { currency: parsed.currency, value: parsed.value };
};
